import { logEvent } from './logGaEvent'
import { flyGaLogic } from '../../listings-client/util/flyGaLogic'

const removeSpaceAndLowercase = (str) => {
  return str.toLowerCase().replace(/ /g, '_')
}

const getLogParams = ({ filterName, filterType, filterItem, enabledFlag }) => ({
  product_name: 'air',
  page_name: 'listings',
  filter_name: filterName,
  filter_type: filterType || '',
  filter_item: filterItem || '',
  enabled_flag: enabledFlag || '',
})

// GA4
const logFilterEvent = (filterParams) => {
  const attributes = getLogParams(filterParams)
  logEvent('filter', attributes)
}

//GA3
const logFilterEventGA3 = ({ action, label }) => {
  flyGaLogic.fire.logFilter({
    action: action,
    label: label,
  })
}

// done
const logStopsFilter = ({ numStops, isDynamic = false, enabled }) => {
  const stopsCount = numStops == '0' ? 'non_stop' : numStops == '1' ? '1_stop' : '2_stops'
  logFilterEvent({
    filterName: isDynamic ? 'chip' : 'stops',
    filterType: isDynamic ? 'dynamic' : 'static',
    filterItem: stopsCount,
    enabledFlag: enabled ? 'y' : 'n',
  })

  logFilterEventGA3({
    action: 'stops',
    label: stopsCount,
  })
}

const logDurationFilter = ({ duration = '', isDynamic = false }) => {
  logFilterEvent({
    filterName: isDynamic ? 'chip' : 'duration',
    filterType: isDynamic ? 'dynamic' : 'static',
    filterItem: duration, // e.g. '12h35m'
  })

  logFilterEventGA3({
    action: 'duration',
    label: duration,
  })
}

// done
const logAirportFilter = ({ airport, isOnly, isDynamic = false, enabled }) => {
  const airportName = airport.toLowerCase()
  logFilterEvent({
    filterName: isDynamic ? 'chip' : 'airports',
    filterType: isOnly ? 'only' : isDynamic ? 'dynamic' : 'static',
    filterItem: airportName,
    enabledFlag: enabled ? 'y' : 'n',
  })

  logFilterEventGA3({
    action: 'airports',
    label: airportName,
  })
}

// done
const logAirlinesFilter = ({ airlineCode, isOnly, isDynamic = false, enabled }) => {
  const airline = airlineCode.toLowerCase()
  logFilterEvent({
    filterName: isDynamic ? 'chip' : 'airlines',
    filterType: isOnly ? 'only' : isDynamic ? 'dynamic' : 'static',
    filterItem: airline,
    enabledFlag: enabled ? 'y' : 'n',
  })

  logFilterEventGA3({
    action: 'airlines',
    label: airline,
  })
}

//done
const logAttributesFilter = ({ attribute, isDynamic = false, enabled }) => {
  const attributeLogValues = {
    CARRY_ON: 'carry-on bag',
    SEATS: 'seats',
    CHANGES: 'changes',
  }
  logFilterEvent({
    filterName: isDynamic ? 'chip' : 'attribute',
    filterType: isDynamic ? 'dynamic' : `static`,
    filterItem: attributeLogValues[attribute],
    enabledFlag: enabled ? 'y' : 'n',
  })

  logFilterEventGA3({
    action: 'attribute filter',
    label: attribute,
  })
}

const logTimeChipFilter = ({ type, label, isDynamic = false, enabled }) => {
  logFilterEvent({
    filterName: isDynamic ? 'chip' : removeSpaceAndLowercase(`time filter ${type}`), // takeoff/landing
    filterType: isDynamic ? 'dynamic' : `static`,
    filterItem: removeSpaceAndLowercase(label), // 'early_morning', 'morning', etc.
    enabledFlag: enabled ? 'y' : 'n',
  })

  logFilterEventGA3({
    action: `time filter chip ${type}`,
    label,
  })
}

export {
  logStopsFilter,
  logDurationFilter,
  logAirportFilter,
  logAirlinesFilter,
  logAttributesFilter,
  logTimeChipFilter,
}
